<template>
  <div :class="$style.container">
    <Title
      strong
      bold
    >
      <template v-if="donationWay === donationWayType.ECPAY_PERIOD_CREDIT || donationWay === donationWayType.LINEPAY_PERIOD">
      {{ steps.DONATION_PERIOD }}
      </template>
      <template v-else>
      {{ steps.DONATION_SINGLE }}
      </template>
    </Title>
    <template v-if="donationWay === donationWayType.ECPAY_PERIOD_CREDIT || donationWay === donationWayType.ECPAY_SINGLE_CREDIT ">
      <span v-if="environment == 'development' || environment == 'staging' ">
        現在是測試環境（{{ environment }}）<br>
        綠界測試卡號：4311-9522-2222-2222 <br>
        有效期限：12/{{ (new Date().getFullYear()+1).toString().slice(-2) }}  安全碼 : 222
      </span>
    </template>

    <div v-if="donationWay === donationWayType.LINEPAY_SINGLE || donationWay === donationWayType.LINEPAY_PERIOD">
      即將跳轉到 LINE Pay 頁面
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapMutations, mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
// configs
import steps from '@/configs/steps';
import donationWayType from '@/configs/donationWay';
import { DONATION_WAY_TO_DONATION_GA_INFO } from '@/configs/GAconfig.js';

import Title from '../../components/Title';

export default {
  components: {
    Title,
  },

  data() {
    return {
      steps: Object.freeze(steps),
      donationWayType: Object.freeze(donationWayType),
      environment: process.env.NODE_ENV,
    };
  },

  computed: {
    ...mapFields('donation', [
      'amount',
      'donationWay',
    ]),

    ...mapFields('donation/ECPay', {
      orderId: 'oppoId',
    }),

    ...mapFields('donation/ECPay', [
      'ecpayUrl',
      'ecpayInfo',
      'ecpayToken',
    ]),

    ...mapGetters('ui', [
      'isTabletLandscapeUp',
    ]),
  },

  beforeRouteLeave: function(to, from, next) {
    this.hideECPayBlock();
    next();
  },

  mounted() {
    this.sendGA();
    switch(this.donationWay) {
      case donationWayType.ECPAY_SINGLE_CREDIT:
      case donationWayType.ECPAY_PERIOD_CREDIT:
      case donationWayType.ECPAY_SINGLE_ATM:
      case donationWayType.ECPAY_SINGLE_CVS:
        this.initializeECPayTransaction();
        break;
      case donationWayType.JKOPAY_SINGLE:
        this.createJKOPayTransaction();
        break;
      case donationWayType.LINEPAY_SINGLE:
      case donationWayType.LINEPAY_PERIOD:
        this.createLinePayTransaction();
        break;
    }
  },

  methods: {
    ...mapMutations('donation/ECPay', {
      updateECPay_ATM_CSV_Result: 'update_ATM_CSV_Result',
    }),

    ...mapActions('donation/ECPay', {
      createECPayTransaction: 'createTransaction',
      updateECPayResultToSaleforce: 'updateResultToSaleforce',
    }),

    ...mapActions('donation/LinePay', {
      getLinePaymentUrl: 'getPaymentUrl',
    }),

    ...mapActions('donation/JKOPay', {
      getJKOPaymentUrl: 'createJKOPayPaymentURL',
    }),

    isMobileDevice() {
      return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1);
    },

    sendGA() {
      const GA_DONATION_INFO = DONATION_WAY_TO_DONATION_GA_INFO[this.donationWay];
      if (!GA_DONATION_INFO) {
        console.warn('Unknown donation way:', this.donationWay);
        return;
      }
      const GA_PARM = {
        ecommerce: {
          currency: 'TWD',
          value: parseFloat(this.amount),
          items: [GA_DONATION_INFO['item']],
          payment_type: GA_DONATION_INFO['payment_type'],
        },
      };
      this.$gtag.event('TD_add_payment_info', GA_PARM);
    },

    async createJKOPayTransaction() {
      try {
        const paymentUrl = await this.getJKOPaymentUrl();
        window.location = paymentUrl;
      } catch(error) {
        alert(error);
      }
    },

    createLinePayTransaction() {
      this.getLinePaymentUrl().then((url)=>{
        window.location = this.isMobileDevice() ? url.app : url.web;
      });
    },

    ECPayErrorHandling(err) {
      alert(`錯誤訊息：「${err}」。將跳轉到上一頁，請重新嘗試`);
      this.$router.push({ name: 'single-confirm' });
    },

    initializeECPayTransaction() {
      // 載入綠界 SDK
      const loader = this.$loading.show();
      const ECPaySDK = document.createElement('script');
      ECPaySDK.src = 'https://ecpg-stage.ecpay.com.tw/Scripts/sdk-1.0.0.js?t=20210121100116';
      document.getElementById('ECPayBlock').appendChild(ECPaySDK);
      // 初始化綠界 SDK
      const serverType = process.env.NODE_ENV === 'development' ? 'Stage' : 'Prod';
      const isLoading = 1;
      const self = this;
      ECPaySDK.onload = function() {
        try {
          window.ECPay.initialize(serverType, isLoading, () => {
            window.ECPay.createPayment(self.ecpayToken, 'zh-TW', (errMessage) => {
              try{
                if(errMessage) {
                  throw errMessage;
                }
                // 綠界 css 會導致字變大，因此移除
                const ECPayFrameCss = $('link[rel=stylesheet][href*="frame.css"]');
                ECPayFrameCss.remove();
                self.showECPayBlock();
                loader.hide();
              } catch (err) {
                self.ECPayErrorHandling(err);
              }
            });
          });
        } catch (err) {
          this.ECPayErrorHandling(err);
        }
      };
    },

    showECPayBlock() { // 顯示綠界付款介面
      const ECPayBlock = document.getElementById('ECPayBlock');
      const btnPay = document.getElementById('btnPay');
      ECPayBlock.style.display = 'block';
      btnPay.addEventListener('click', () =>{
        this.onClickECPayBtn();
      }); // 只能點一次，避免多次觸發
    },

    hideECPayBlock() { // 顯示綠界付款介面
      if(document.getElementById('ECPayBlock')) {
        document.getElementById('ECPayBlock').style.display = 'none';
      }
    },

    onClickECPayBtn: _.debounce(function() {
      window.ECPay.getPayToken(async(paymentInfo, errMsg) =>{
        if(errMsg) {
          if(errMsg == '請輸入卡號') {
            errMsg = '請改用手動方式輸入卡號，勿使用自動帶入功能';
          }
          alert(`錯誤訊息：${errMsg}`);
          return;
        }
        if(!paymentInfo && !errMsg) {
        // 使用者填寫錯誤資料時，觸發 ECPay.getPayToken 時，不會發 getPayToken API，直接觸發 call back
          return;
        }
        const loader = this.$loading.show();
        try {
          const token = paymentInfo.PayToken;
          const result = await this.createECPayTransaction(token);
          if(this.donationWay == donationWayType.ECPAY_SINGLE_CREDIT || this.donationWay == donationWayType.ECPAY_PERIOD_CREDIT) {
            const url = result.data.ECPayData.ThreeDInfo.ThreeDURL;
            window.location = url;
          } else {
            this.updateECPay_ATM_CSV_Result(result.data.ECPayData);
            this.updateECPayResultToSaleforce();
            this.hideECPayBlock();
            this.$router.push({ name: 'single-result' });
          }
          loader.hide();
        } catch (err) {
          this.ECPayErrorHandling(err);
          loader.hide();
        }
      });
    }, 500),

  },

};

</script>

<style lang="scss" module>
@import '~@/styles/02-tools/tools.box';

.container {
  @include box;

  top: 200px;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  will-change: transform;
}
</style>
